// DocumentCreateForm.jsx
import React, { useState } from "react";
import { createDocument } from "../../api/numberingApi";

function DocumentCreateForm({ client_id, onCreate }) {
  const [documentType, setDocumentType] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(null);
  const [creating, setCreating] = useState(false);
  const [createdDocNumber, setCreatedDocNumber] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (!client_id) {
      setError("Client ID is missing.");
      return;
    }
    if (!documentType) {
      setError("Please select a document type.");
      return;
    }

    setCreating(true);
    try {
      const createdDoc = await createDocument(client_id, documentType, description);
      setCreatedDocNumber(createdDoc.document_number);
      alert(`Document created successfully with number: ${createdDoc.document_number}`);
      setDescription("");
      setDocumentType("");
      if (onCreate) onCreate();
    } catch (err) {
      setError(err.message || "Failed to create document.");
    } finally {
      setCreating(false);
    }
  }

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-md shadow border border-gray-200">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">Create Document</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="documentType" className="block mb-1 font-medium text-gray-700">
            Document Type
          </label>
          <select
            id="documentType"
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            <option value="" disabled>
              Select document type
            </option>
            <option value="Invoice">Invoice</option>
            <option value="Booking">Booking</option>
            <option value="Credit Note">Credit Note</option>
            {/* Add other types if needed */}
          </select>
        </div>

        <div>
          <label htmlFor="description" className="block mb-1 font-medium text-gray-700">
            Description
          </label>
          <input
            id="description"
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Optional description"
          />
        </div>

        {createdDocNumber && (
          <p className="text-green-600 font-semibold">
            Created Document Number: {createdDocNumber}
          </p>
        )}

        {error && (
          <p className="text-red-600 font-semibold">{error}</p>
        )}

        <button
          type="submit"
          disabled={creating}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded shadow disabled:opacity-50"
        >
          {creating ? "Creating..." : "Create Document"}
        </button>
      </form>
    </div>
  );
}

export default DocumentCreateForm;
